import React from 'react';
import { FadeIn, CTAButton, Section } from './Shared';
import { useCountdown } from '../hooks/useCountdown';
import { ShieldCheck, Lock, CreditCard, Star, XCircle } from 'lucide-react';
export const UrgencyBar = () => {
  const {
    hours,
    minutes,
    seconds
  } = useCountdown();
  return <div className="bg-navy text-white py-2 md:py-3 px-3 md:px-4 sticky top-0 z-50 shadow-md" data-id="element-270">
      <div className="max-w-4xl mx-auto flex flex-row items-center justify-center gap-1.5 md:gap-6 text-center text-[11px] md:text-base font-medium" data-id="element-271">
        <div className="flex items-center gap-1 md:gap-2" data-id="element-272">
          <span className="animate-pulse hidden md:inline" data-id="element-273">⏰</span>
          <span className="hidden md:inline" data-id="element-274">
            PRECIO DE LANZAMIENTO — CIERRA EN:
          </span>
          <span className="md:hidden" data-id="element-275">LANZAMIENTO —</span>
          <span className="font-bold bg-white/20 px-1.5 md:px-2 py-0.5 md:py-1 rounded text-xs md:text-base" data-id="element-276">
            {hours.toString().padStart(2, '0')}:
            {minutes.toString().padStart(2, '0')}:
            {seconds.toString().padStart(2, '0')}
          </span>
        </div>
        <span className="text-brandOrange font-bold text-[10px] md:text-base" data-id="element-277">
          Sube $15.000. No vuelve.
        </span>
      </div>
    </div>;
};
export const Hero = () => {
  return <Section className="bg-[#0b1929] pt-4 md:pt-16 pb-8 md:pb-16" data-id="element-278">
      <div className="max-w-4xl mx-auto text-center space-y-4 md:space-y-8" data-id="element-279">
        <FadeIn data-id="element-280">
          <div className="space-y-2 md:space-y-6" data-id="element-281">
            <div className="inline-block bg-white/10 text-white font-bold px-4 py-1.5 rounded-full mb-1 md:mb-2 text-[12px] md:text-[14px] border border-white/10" data-id="element-282">
              EL ARSENAL DEL PROFE™
            </div>
            <h1 className="text-[32px] leading-tight md:text-5xl lg:text-6xl font-extrabold text-white" data-id="element-283">
              Todo tu año de Educación Física.
              <br data-id="element-284" />
              <span className="text-brandOrange" data-id="element-285">Listo. Desde hoy.</span>
            </h1>
          </div>
        </FadeIn>

        <FadeIn delay={0.15} data-id="element-286">
          <a href="#pricing" className="block cursor-pointer" data-id="element-287">
            <img src="https://cdn.magicpatterns.com/uploads/m24tX2QfVjgY5cQRyyupXG/quiero_que_me_202604132324_-_Editado.png" alt="El Arsenal del Profe Mockup" className="w-full max-w-[280px] md:max-w-xl mx-auto h-auto object-contain hover:scale-[1.02] transition-transform duration-300 drop-shadow-2xl" data-id="element-288" />
          </a>
          <p className="text-lg md:text-2xl font-bold text-brandOrange mt-4" data-id="element-289">
            Sistema Completo de Clases Listas Para Usar
          </p>
          <p className="text-gray-300 mt-1 text-sm md:text-base" data-id="element-290">
            El sistema N°1 para profes de Educación Física en Argentina —
            Primaria + Secundaria — Todos los niveles
          </p>
        </FadeIn>

        <FadeIn delay={0.25} data-id="element-291">
          <div className="max-w-2xl mx-auto space-y-4 md:space-y-6" data-id="element-292">
            <div className="flex flex-wrap justify-center gap-2" data-id="element-293">
              <span className="bg-white/15 text-white px-3 py-1.5 rounded-full text-xs md:text-sm font-medium inline-flex items-center gap-1.5 border border-white/20 backdrop-blur-sm" data-id="element-294">
                <span className="text-base" data-id="element-295">📄</span> 100% PDF
              </span>
              <span className="bg-white/15 text-white px-3 py-1.5 rounded-full text-xs md:text-sm font-medium inline-flex items-center gap-1.5 border border-white/20 backdrop-blur-sm" data-id="element-296">
                <span className="text-base" data-id="element-297">⚡</span> Acceso en 5 minutos
              </span>
              <span className="bg-white/15 text-white px-3 py-1.5 rounded-full text-xs md:text-sm font-medium inline-flex items-center gap-1.5 border border-white/20 backdrop-blur-sm" data-id="element-298">
                <span className="text-base" data-id="element-299">🇦🇷</span> Primaria + Secundaria
              </span>
              <span className="bg-white/15 text-white px-3 py-1.5 rounded-full text-xs md:text-sm font-medium inline-flex items-center gap-1.5 border border-white/20 backdrop-blur-sm" data-id="element-300">
                <span className="text-base" data-id="element-301">🎯</span> Sin materiales + Con
                materiales
              </span>
              <span className="bg-white/15 text-white px-3 py-1.5 rounded-full text-xs md:text-sm font-medium inline-flex items-center gap-1.5 border border-white/20 backdrop-blur-sm" data-id="element-302">
                <span className="text-base" data-id="element-303">📚</span> 120+ actividades listas
              </span>
            </div>

            <div className="space-y-3 pt-2" data-id="element-304">
              <CTAButton href="#pricing" fullWidth className="text-lg md:text-xl py-3 md:py-5" data-id="element-305">
                QUIERO EL MEGAPACK AHORA →
              </CTAButton>

              <div className="flex flex-wrap items-center justify-center gap-3 md:gap-4 text-[10px] md:text-xs text-gray-400 font-medium" data-id="element-306">
                <span className="flex items-center gap-1" data-id="element-307">
                  <ShieldCheck size={14} className="text-green-500" data-id="element-308" /> Garantía
                  30 días
                </span>
                <span className="flex items-center gap-1" data-id="element-309">
                  <Lock size={14} className="text-gray-400" data-id="element-310" /> Pago seguro
                </span>
                <span className="flex items-center gap-1" data-id="element-311">
                  <CreditCard size={14} className="text-blue-400" data-id="element-312" /> Mercado
                  Pago | Tarjeta | Transferencia
                </span>
              </div>
            </div>
          </div>
        </FadeIn>
      </div>
    </Section>;
};
export const SocialProof = () => {
  return <div className="bg-slate-200 border-y border-slate-300 py-10" data-id="element-313">
      <div className="max-w-6xl mx-auto px-4" data-id="element-314">
        <div className="grid grid-cols-2 md:grid-cols-4 gap-8 text-center divide-x divide-slate-300" data-id="element-315">
          <FadeIn delay={0.1} data-id="element-316">
            <div className="text-3xl md:text-4xl font-bold text-navy mb-1" data-id="element-317">
              +500
            </div>
            <div className="text-sm text-gray-600 font-medium" data-id="element-318">
              profes confían
            </div>
          </FadeIn>
          <FadeIn delay={0.2} data-id="element-319">
            <div className="text-3xl md:text-4xl font-bold text-navy mb-1" data-id="element-320">
              6
            </div>
            <div className="text-sm text-gray-600 font-medium" data-id="element-321">
              Tomos listos
            </div>
          </FadeIn>
          <FadeIn delay={0.3} data-id="element-322">
            <div className="text-3xl md:text-4xl font-bold text-navy mb-1" data-id="element-323">
              6
            </div>
            <div className="text-sm text-gray-600 font-medium" data-id="element-324">
              Bonos incluidos
            </div>
          </FadeIn>
          <FadeIn delay={0.4} data-id="element-325">
            <div className="text-3xl md:text-4xl font-bold text-navy mb-1" data-id="element-326">
              4.9/5
            </div>
            <div className="text-sm text-gray-600 font-medium flex items-center justify-center gap-1" data-id="element-327">
              calificación{' '}
              <Star size={14} className="fill-yellow-400 text-yellow-400" data-id="element-328" />
            </div>
          </FadeIn>
        </div>
      </div>
    </div>;
};
export const Testimonials1 = () => {
  const testimonials = [{
    initials: 'MR',
    text: 'Llegué al lunes con todo listo por primera vez en años. Los juegos sin materiales me salvaron cuando el depósito estaba cerrado. No lo puedo creer.',
    author: 'Marcelo R., Buenos Aires',
    role: 'Profe de Ed. Física'
  }, {
    initials: 'CP',
    text: 'Tengo grupos de 40 chicos y espacio mínimo. El bono de Espacios Chicos resolvió algo que no sabía cómo resolver hace 3 años.',
    author: 'Carolina P., Córdoba',
    role: 'Escuela Primaria'
  }, {
    initials: 'DG',
    text: 'El domingo a la noche ya no me angustia. Abro el Tomo 6 y en 10 minutos tengo la clase del lunes armada de punta a punta.',
    author: 'Diego G., Rosario',
    role: 'Secundaria Técnica'
  }];
  return <Section className="bg-slate-200/80" data-id="element-329">
      <div className="grid md:grid-cols-3 gap-6" data-id="element-330">
        {testimonials.map((t, i) => <FadeIn key={i} delay={i * 0.1} data-id="element-331">
            <div className="bg-white p-8 rounded-2xl shadow-lg shadow-slate-200/50 border border-slate-100 h-full flex flex-col" data-id="element-332">
              <div className="flex items-center gap-4 mb-4" data-id="element-333">
                <div className="w-12 h-12 bg-navy text-white rounded-full flex items-center justify-center font-bold text-lg" data-id="element-334">
                  {t.initials}
                </div>
                <div className="flex text-yellow-400" data-id="element-335">
                  {[...Array(5)].map((_, j) => <Star key={j} size={16} className="fill-current" data-id="element-336" />)}
                </div>
              </div>
              <p className="text-gray-700 italic mb-6 flex-grow" data-id="element-337">"{t.text}"</p>
              <div data-id="element-338">
                <p className="font-bold text-navy" data-id="element-339">{t.author}</p>
                <p className="text-sm text-gray-500" data-id="element-340">{t.role}</p>
              </div>
            </div>
          </FadeIn>)}
      </div>
    </Section>;
};
export const Problem = () => {
  const painPoints = ['Domingo buscando juegos en YouTube e Instagram que nunca quedan bien para tu grupo', 'Clases armadas la noche anterior, a las corridas, con lo que encontrás', 'Siempre los mismos juegos porque no tenés un banco de actividades serio', 'El día de lluvia sin plan B y el grupo se te va de las manos', 'Grupos grandes con poco espacio y sin saber qué hacer con eso', 'Fin de semana agotado y el domingo a la noche volvés a empezar el mismo ciclo'];
  return <Section className="bg-navy text-white" data-id="element-341">
      <div className="max-w-3xl mx-auto" data-id="element-342">
        <FadeIn data-id="element-343">
          <h2 className="text-3xl md:text-5xl font-bold mb-8 text-center text-brandOrange" data-id="element-344">
            ¿Cuántos domingos más vas a perder así?
          </h2>

          <div className="space-y-4 text-lg text-gray-200 mb-12" data-id="element-345">
            <p data-id="element-346">Sos profe de Educación Física.</p>
            <p data-id="element-347">
              Elegiste esta profesión porque amás el movimiento, el deporte y
              ver a tus alumnos crecer.
            </p>
            <p data-id="element-348">
              Pero nadie te dijo que ibas a pasar los domingos buscando juegos
              que no encajan con tu grupo, armando clases a último momento y
              llegando al lunes con algo que "más o menos sirve".
            </p>
            <p className="font-bold text-white text-xl pt-4" data-id="element-349">
              No es falta de vocación.
              <br data-id="element-350" />
              Es falta de un sistema.
            </p>
          </div>

          <div className="bg-white/5 border border-white/10 rounded-2xl p-6 md:p-8 space-y-4 mb-10" data-id="element-351">
            {painPoints.map((point, i) => <div key={i} className="flex items-start gap-3" data-id="element-352">
                <XCircle className="text-red-400 shrink-0 mt-1" size={24} data-id="element-353" />
                <p className="text-gray-300" data-id="element-354">{point}</p>
              </div>)}
          </div>

          <p className="text-2xl md:text-3xl font-bold text-center text-white" data-id="element-355">
            ¿Y si este fuera el último domingo que pasás así?
          </p>
        </FadeIn>
      </div>
    </Section>;
};